/**
 * Typed access to the tenant asset-folder list. The single source of truth is
 * `./tenantFolders.json`, one entry per pack in `src/config/tenants.ts`. It is
 * JSON (not TS) because `vite.config.ts` lives in the separate composite
 * `tsconfig.node.json` project and imports the list at config-eval time; a
 * shared `.ts` module would be claimed by both TypeScript programs and fail
 * the build with TS6305. Runtime code should import via `src/config/tenants.ts`.
 */
import tenantFoldersJson from "./tenantFolders.json";

export const tenantFolders: readonly string[] = tenantFoldersJson;
